"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitUntil = waitUntil;

function waitUntil(condition, callback) {
  return new Promise(function (resolve, reject) {
    var interval = setInterval(function () {
      if (condition()) {
        clearInterval(interval);
        callback(resolve, reject);
      }
    }, 100);
  });
}